module.exports = __webpack_public_path__ + "img/19.a674e5fe.jpg";